export default __webpack_public_path__ + "static/havant-3-822b33276fd7ce47dd69a6b4b3bd275c.jpg";